import React from 'react'

const Clipboard = ({ color = '#DC7B19', size = '5' }) => {
  return (
    <svg
      className={`h-${size} w-${size}`}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3C8 2.44772 8.44772 2 9 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H9C8.44772 4 8 3.55228 8 3Z"
        fill={color}
      />
      <path
        d="M6 3C4.89543 3 4 3.89543 4 5V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V5C16 3.89543 15.1046 3 14 3C14 4.65685 12.6569 6 11 6H9C7.34315 6 6 4.65685 6 3Z"
        fill={color}
      />
    </svg>
  )
}

export default Clipboard
